module.exports = __webpack_public_path__ + "img/maple-tree.28e9b835.svg";